module.exports = __webpack_public_path__ + "img/forgot-password-v2.576a8e40.svg";